import { BrandResponse } from './brand-client.types';

/**
 * Determines if a brand is missing the 2025 profile fields.
 * Brands created before 2025 features will have empty/null brand_metadata.
 *
 * @param brand - The brand object to check
 * @returns true if the brand is missing brand_metadata, false otherwise
 */
export const isLegacyBrand = (brand: BrandResponse | null | undefined): boolean => {
  if (!brand) return false;

  // Check if brand_metadata is empty or null
  const hasBrandMetadata = !!brand.brand_metadata && Object.keys(brand.brand_metadata).length > 0;
  const hasNiche = !!brand.niche_id;

  return !hasBrandMetadata && !hasNiche;
};
